// extracted by mini-css-extract-plugin
export default {"container":"HobbieCard_container__dUarI","floating":"HobbieCard_floating__162bI","beat":"HobbieCard_beat__siYnl","moveGradient":"HobbieCard_moveGradient__Zv55x"};